module.exports = __webpack_public_path__ + "img/user-07.77bf1d91.jpg";